import { null as zNull } from "zod/v4";

export const disconnectLuminousIntegration = {
  name: "disconnectLuminousIntegration" as const,
  input: zNull(),
  output: zNull(),
};
